<template>
<div>
  
         <div class="bg_gray"></div>
         <div class="shoppingMy">
            <div class="userInfo">
                <div class="infoTop">
                    <img src="@/assets/images/btn_message@2x.png" alt="">
                </div>

                <div class="accountInfo flex">
                    <div class="userHeadPortrait">
                        <img src="@/assets/images/pic_head portrait_sign in@2x.png" alt="" class="portrait">
                        <img src="@/assets/images/icon_vip@2x.png" alt="" class="authentication">
                    </div>
                    <div class="account">
                        <div class="name">张飞羽</div>
                        <div class="phone">16666666666</div>
                    </div>
                </div>

            </div>

            <div class="orderInfo">
              <!-- 订单中心 -->
                  <div class="orderCore box">
                        <div class="coreTop flex_between">
                            <div class="coreText">订单中心</div>
                            <div class="allOrderText">全部订单 <van-icon name="arrow" /></div>
                        </div>
                        <div class="orderClassify flex_around">
                          <div>
                              <div class="orderClassImg">
                                <img src="@/assets/images/icon_confirm@2x.png" alt="" />
                              </div>
                              <div class="orderClassText">待确认</div>
                          </div>
                          <div>
                              <div class="orderClassImg">
                                <img src="@/assets/images/icon_obligation@2x.png" alt="" />
                              </div>
                              <div class="orderClassText">待付款</div>
                          </div>
                           <div>
                              <div class="orderClassImg">
                                <img src="@/assets/images/icon_distribution@2x.png" alt="" />
                              </div>
                              <div class="orderClassText">配货中</div>
                          </div>
                           <div>
                              <div class="orderClassImg">
                                <img src="@/assets/images/icon_transit@2x.png" alt="" />
                              </div>
                              <div class="orderClassText">待收货</div>
                          </div>
                        </div>
                  </div>
                  <!-- 提现额度 -->
                   <div class="quota box">
                        <div class="quotaTop flex_between">
                            <div class="withdrawalQuota">可提现(元)</div>
                            <div class="withdrawalRecord">提现记录 <van-icon name="arrow" /></div>
                        </div>
                        <!-- 提现额度 -->
                        <div class="withdrawalQuotaNumber">10000.00</div>
                         <div class="withdrawalQuotaInfo flex_around">
                            <div>
                                 <div class="tobeRecorded quotaClassify">
                                   待入账(元)
                                 </div>
                                 <div class="quoatMoney">190.59</div>
                            </div>          
                            <div>
                                 <div class="quotaClassify">
                                   提现中(元)
                                 </div>
                                 <div class="quoatMoney">500.59</div>
                            </div>          
                            <div>
                                 <div class="quotaClassify">
                                   已提现(元)
                                 </div>
                                 <div class="quoatMoney">1900.59</div>
                            </div>
                         </div>   
                         <div class="withdrawalBtn">
                          立即提现
                         </div>
                   </div>
                  <!--  -->
                  <div class="OfflineCommission flex">
                    <div class="commission commissionBox flex">
                        <div class="commissionImg"><img src="@/assets/images/icon_commission@2x.png" alt=""></div>
                        <div class="commissionInfo">
                          <div class="commissionInfoNumber">
                            19200.50  <van-icon name="arrow" />
                          </div>
                          <div class="commissionInfoText">
                            累计佣金(元)
                          </div>
                        </div>
                    </div>
                    <div class="offline commissionBox flex">
                        <div class="commissionImg"><img src="@/assets/images/icon_advocate@2x.png" alt=""></div>
                        <div class="commissionInfo">
                          <div class="commissionInfoNumber">
                            120   <van-icon name="arrow" />
                          </div>
                          <div class="commissionInfoText">
                            下线总数(人)
                          </div>
                        </div>
                    </div>
                  </div>
                    <div class="course box">

                    </div>
            </div>
         </div>
        <footer class="foot">
             <div class="flex-around">
                 <div @click="linkMall">
                    <div class="footerboximg"><img src="@/assets/images/icon_mall-nor@2x.png" alt="" /></div>         
                    <div class="footerText">商城</div>
                 </div>
                  <div @click="linkCart">
                    <div class="footerboximg"><img src="@/assets/images/icon_trolley_nor@2x.png" alt="" /></div>         
                    <div class="footerText">购物车</div>
                 </div>
                  <div @click="linkMy">
                     <div class="footerboximg"><img src="@/assets/images/icon_personal_sel@2x.png" alt="" /></div>
                     <div class="footerText">我的</div>
                 </div>
            </div>
        </footer>
</div>

</template>

<script>
export default {
    methods:{
      linkMall(){
        this.$router.push({name:"shoppingMall"})
      },      
      linkCart(){
        this.$router.push({name:"shoppingCart"})
      },      
      linkMy(){
        this.$router.push({name:"shoppingMy"})
      },

    }
}
</script>

<style lang="scss" scoped>
::v-deep{
  .van-icon{
    top: 2px;
    color: #666666;
  }
}
.bg_gray {
    background: #F6F6F6;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1;
}
.shoppingMy{
    position: relative;
    z-index: 1;
    width: 100;
    padding: 0 0 0px 0;
    .userInfo{
      width: 100%;
      height: 440px;
      background: url('~@/assets/images/pic_my_top@2x.png'),no-repeat;
      background-size: 100% 100%;
      padding: 10px 20px 0px;
      .infoTop{
          padding: 20px 10px;
          height: 68px;
          img{
            float: right;
            height: 44px;
            width: 44px;
          }
      }
      .accountInfo{
        width: 100%;
        height: 100px;
        margin-top: 40px;
        padding: 0px 20px;
        .userHeadPortrait{
          width: 100px;
          height:100% ;
          position: relative;
          .portrait{
            width: 100%;
            height: 100%;
          }
          .authentication{
            width: 32px;
            height: 32px;
            position: absolute;
            right: 0;
            bottom: 0;
          }
        }
        .account{
          flex: 1;
          height: 100%;
          margin-left: 40px;
          padding: 10px 0;
          .name{
            font-size: 36px;
            font-weight: 500;
            color: #242424;
          }
          .phone{
            font-size: 28px;
            font-weight: 400;
            color: #999999;
          }
        }
      }
    }
    .orderInfo{
      position: relative;
      top: -150px;
      padding: 0px 24px;
      width: 100%;
      .orderCore{
        height: 252px;
        .coreTop{
          padding: 32px;
          border-bottom: 1px solid #E9E9E9;
          .coreText{
            font-size: 32px;
            font-weight: 500;
            color: #242424;
          }
          .allOrderText{
            font-size: 24px;
            font-weight: 400;
            color: #666666;
            line-height: 44px;
          }
        }
        .orderClassify{
          padding: 30px 0;
          .orderClassImg{
            width: 60px;
            height: 60px;
            margin: 0 auto;
          }
          .orderClassText{
            font-size: 28px;
            color: #666666;
          }
        }
      }
      .quota{
        height: 396px;
        .quotaTop{
          padding: 32px 32px 10px;
          color: #666666;
          .withdrawalQuota{
            font-size: 28px;
          }
          .withdrawalRecord{
            font-size: 24px;
            line-height: 36px;
          }
        }
        .withdrawalQuotaNumber{
          padding-left: 32px;
          font-size: 48px;
          font-weight: 500;
          color: #FF4F37;
        }
        .withdrawalQuotaInfo{
          margin: 20px 0;
          .quotaClassify{
            margin:  0 auto;
            font-size: 24px;
            color: #999999;
          }
          .quoatMoney{
            font-size: 32px;
            font-weight: 500;
            color: #242424;
          }
          .tobeRecorded{

          }
        }
        .withdrawalBtn{
          margin: 40px auto 0;
          width: 400px;
          height: 80px;
          background: linear-gradient(90deg, #F05752 0%, #F07556 100%);
          border-radius: 40px 40px 40px 40px;
          font-size: 28px;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 80px;
          text-align: center;
        }
      }
      .OfflineCommission{
          height: 160px;
          margin-bottom: 24px;
          .commission{
            margin-right: 20px;
          }
          .offline{
          }
          .commissionImg{
            width: 80px;
            height: 80px;
            img{
              width: 100%;
              height: 100%;
            }
          }
          .commissionInfo{
            margin-left: 16px;
            .commissionInfoNumber{
              margin-top: -6px;
              font-size: 40px;
              font-weight: 500;
              color: #242424;
              .van-icon{
                font-size: 28px;
                top: -3px;
              }
            }
            .commissionInfoText{
              margin-top: 8px;
              font-weight: 400;
              color: #999999;
              font-size: 24px;
            }
          }
          .commissionBox{
            flex: 6;
            padding: 40px 0 0 24px;
            border-radius: 24px 24px 24px 24px;
            background-color: #fff;

          }
      }
      .course{
        width: 100%;
        height: 250px;
        margin-top: 40px;
        background: url('~@/assets/images/pic_banner_sell@2x.png'),no-repeat;
        background-size: 100% 100%;
      }
    }
}
.foot{
    width: 100%;
    height: 100px;
    position: fixed;
    bottom: 0;
    left: 0;
    background-color: #fff;
    z-index: 1;
    font-size: 22px;
    color: #242424;
    .footerboximg {
    margin: 10px auto 0px;
    width: 48px;
    height: 48px;
    
    }
    .footerText{
        text-align: center;
    }
}
.box{
  background-color: #fff;
  border-radius: 24px 24px 24px 24px;
  width: 100%;
  margin-bottom: 40px;
}
.flex{
  display: flex;
}
.flex_between{
  display: flex;
  justify-content: space-between;
}
.flex_around{
  display: flex;
  justify-content: space-around;
}
</style>